import React from 'react';
import PropTypes from 'prop-types';
import Section from './children/Section/Section';
import IconHeader from '../../../../../shared/components/IconHeader/IconHeader';
import dataExportIcon from '../../../../../static/images/data-export-icons/Data-Chart-Icon-WHITE.svg';
import coverageIcon from '../../../../../static/images/data-export-icons/PieChart-Icon.svg';
import departureIcon from '../../../../../static/images/data-export-icons/Departures-Icons-WHITE.svg';
import arrivalIcon from '../../../../../static/images/data-export-icons/Arrivals-Icons-WHITE.svg';
import baggageIcon from '../../../../../static/images/data-export-icons/Baggage-Icon-WHITE.svg';
import { openTab } from '../../../../../src/utils/openTab';

const FAQlink = 'https://helpdesk.flightstats.com/hc/en-us/sections/115000035851-Data-Exports';

const MetadataChart = (props) => {
  const { quoteData } = props;
  const metadata = quoteData && quoteData.metadata;


  const overviewData = () => (
    {
      sectionSubtitle: 'The following metrics mean that we were able to "track" the flight indicating that we had either an actual gate time, or a cancellation.',
      items: [
        {
          title: 'Track Percentage',
          percentage: metadata.trackPercentage,
          definition: 'Percentage of flights in which we had both departure and arrival gate time, or the flight was cancelled.',
        },
        {
          title: 'Departure Percentage',
          percentage: metadata.trackDeparturePercentage,
          definition: 'Percentage of flights in which we had a departure gate time, or the flight was cancelled.',
        },
        {
          title: 'Arrival Percentage',
          percentage: metadata.trackArrivalPercentage,
          definition: 'Percentage of flights in which we had a arrival gate time, or the flight was cancelled.',
        },
      ],
    }
  );

  const depData = () => (
    {
      sectionSubtitle: 'These metrics indicate the percent of flights in which we have the following departure data items. These do not include cancelled flights.',
      items: [
        {
          title: 'Actual Gate Time',
          percentage: metadata.actualGateDepartureTimePercentage,
        },
        {
          title: 'Actual Runway Time',
          percentage: metadata.actualRunwayDepartureTimePercentage,
        },
        {
          title: 'Gate Assignment',
          percentage: metadata.departureGatePercentage,
        },
      ],
    }
  );

  const arrData = () => (
    {
      sectionSubtitle: 'These metrics indicate the percent of flights in which we have the following arrival data items. These do not include cancelled flights.',
      items: [
        {
          title: 'Actual Gate Time',
          percentage: metadata.actualGateArrivalTimePercentage,
        },
        {
          title: 'Actual Runway Time',
          percentage: metadata.actualRunwayArrivalTimePercentage,
        },
        {
          title: 'Gate Assignment',
          percentage: metadata.arrivalGatePercentage,
        },
      ],
    }
  );

  const baggageData = () => (
    {
      sectionSubtitle: 'These metrics indicate the percent of flights in which we have the following baggage data items. These do not include cancelled flights.',
      items: [
        {
          title: 'Baggage Claim',
          percentage: metadata.baggagePercentage,
        },
      ],
    }
  );

  return metadata && (
    <div className='metaDataChart'>
      <div className='header row'>
        <div className='col-xs-9'>
          <IconHeader title='Data Export Details' icon={dataExportIcon} />
        </div>
        <div className='col-xs-3' style={{ textAlign: 'right' }}>
          <a className='linkText' href={FAQlink} onClick={e => openTab(FAQlink, e)}>
            What is this?<br />Go to the FAQ
          </a>
        </div>
      </div>
      <div className=''>
        <Section title='Coverage Overview' icon={coverageIcon} metadata={overviewData()} isOverview />
        <Section title='Departure Coverage' icon={departureIcon} metadata={depData()} />
        <Section title='Arrival Coverage' icon={arrivalIcon} metadata={arrData()} />
        <Section title='Baggage Coverage' icon={baggageIcon} metadata={baggageData()} />
      </div>
    </div>
  );
};

MetadataChart.propTypes = {
  quoteData: PropTypes.object,
};

export default MetadataChart;



// WEBPACK FOOTER //
// ./modules/DataExports/components/shared/MetadataChart/MetadataChart.js